var url = "//search.bulbamerica.com/projector/getProjectorModel.php";
function getModel(manufacturer_name){  
    $.ajax({
     type: "POST",
     url: url,
     async: false,
     data: {manufacturer_name: manufacturer_name},
     dataType: "json",
     success: function(data){
       pathname = window.location.pathname.split( '/' );
       model_name = pathname[pathname.length - 1];
       var toAppend = "";
       toAppend = '<option value="">Pick your Model</option>'; 
       $.each(data,function(i,o){
         if(o.value == model_name)
           select = 'selected= "selected"';
         else
           select = '';
       	toAppend += '<option value ="' + o.value + '"' + select + '>'+o.name+'</option>';
       });
       $("#model_filter").empty().append(toAppend);
    }
});
}